import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Pis.css';
import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import * as actions from '../Actions';
import withContext from "../../../withContext";

const service = new Service();

class PisUpdateDetail extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let markdoneData = [];
        let serverSideData = {};
        this.testId = this.props.params.id;
        let _this = this;
        let testImage = '';
        let testComment = "";
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData) {
            console.log("serverSideData::: ", serverSideData);
            if (serverSideData['data1'] && serverSideData['data1']['result']) {
                initialData = serverSideData['data1']['result']['test'].filter(function (item) {
                    return _this.testId == item.id;
                });
            }
            if (serverSideData['data2'] && serverSideData['data2']['result']) {
                markdoneData = serverSideData['data2']['result'];
                if (markdoneData['imageurl'] && markdoneData['imageurl'].trim() != '') {
                    testImage = markdoneData['imageurl'].trim();
                }
                if (markdoneData['comment'] && markdoneData['comment'].trim() != '') {
                    testComment = markdoneData['comment'].trim();
                }
            }
        } 
        this.state = {
            initialData: initialData,
            markdoneData: markdoneData,
            takenonCalDate:markdoneData['date'],
            testSaveStatus: false,
            testImage: testImage,
            testComment: testComment,
            minTestDate: '',
            maxTestDate: '',
            metaTitle: "Pregnancy Checkup Schedule – Tests, Screening, Scans & more",
            metaDescription: [
                { "name": "description", "content": "Prenatal medical care is most important to monitor the health of pregnant woman and baby. Find more about checkups to be done during pregnancy for a healthy baby & You. Get more information about antenatal care at FirstCry Parenting." },
                { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "preginspection/getpregnancyinspectiontest",
            body: JSON.stringify({})
        };
        let obj2 = {
            url: global.api_url + "preginspection/getmarkdonedetails",
            body: JSON.stringify({
                testid: reqUrl.split('/').pop()
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        this.setDateRange();
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.pisData();
            } else {
                localStorage.setItem('pisDataReport' + this.testId, JSON.stringify(this.state.initialData));
            }
            if (!this.state.markdoneData || (this.state.markdoneData && Object.keys(this.state.markdoneData).length < 1)) {
                service.showLoader();
                this.pisMarkDoneData();
            } else {
                localStorage.setItem('pisDataMarkDone' + this.testId, JSON.stringify(this.state.markdoneData));
            }
        } else {
            if (localStorage.getItem('pisDataReport' + this.testId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('pisDataReport' + this.testId)) });
            }
            if (localStorage.getItem('pisDataMarkDone' + this.testId)) {
                let data = JSON.parse(localStorage.getItem('pisDataMarkDone' + this.testId));
                this.setState({ markdoneData: data });
                let comment = (data['comment'] && data['comment'].trim() != '') ? data['comment'] : "";
                if (comment != '') {
                    this.setState({ testComment: comment });
                    document.getElementById('testComment').value = comment;
                }
                let imageurl = (data['imageurl'] && data['imageurl'].trim() != '') ? data['imageurl'] : "";
                if (imageurl != '') {
                    this.setState({ testImage: imageurl });
                    document.getElementById('vaximage').setAttribute('src', imageurl);
                }
            }
            service.hideLoader();
        }
    }

    pisData() {
        var postData = {};
        var url = global.api_ci_url + "Pis/getPisLandingData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                let _this = this;
                let initialData = json['result']['test'].filter(function (item) {
                    return _this.testId == item.id;
                });
                this.setState({ initialData: initialData });
                localStorage.setItem('pisDataReport' + this.testId, JSON.stringify(initialData));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    pisMarkDoneData() {
        var postData = {
            testid: this.testId
        }
        var url = global.api_ci_url + "Pis/getPisMarkDoneData";
        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (json['result']) {
                this.setState({ markdoneData: json['result'] });
                let comment = (json['result']['comment'] && json['result']['comment'].trim() != '') ? json['result']['comment'] : "";
                if (comment != '') {
                    this.setState({ testComment: comment });
                    document.getElementById('testComment').value = comment;
                }
                let imageurl = (json['result']['imageurl'] && json['result']['imageurl'].trim() != '') ? json['result']['imageurl'] : "";
                if (imageurl != '') {
                    this.setState({ testImage: imageurl });
                    document.getElementById('vaximage').setAttribute('src', imageurl);
                }
                localStorage.setItem('pisDataMarkDone' + this.testId, JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    pisFileUpload() {
        service.showLoader();
        var fileObj = document.getElementById("image_upload").files[0];
        if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png") && fileObj.size < 2097152) {
            var file_name = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime() + ".jpg";
            var apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
            service.postFileServiceCall(apiurl, fileObj, file_name).then((json) => {
                console.log(json);
                if (json["result"] == 'success') {
                    document.getElementById('vaximage').setAttribute('src', json['image_url']);
                    this.setState({ testImage: json['image_url'] });
                } else {
                    service.showAlert("Fail");
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Upload Valid Image";
            return;
        }
    }

    setMarkDoneStatus() {
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "testid": this.testId,
                "comment": document.getElementById('testComment').value,
                "imageurl": this.state.testImage,
                "markdate": actions.getDateStringPis(this.state.takenonCalDate)
            }

            var url = global.api_ci_url + "Pis/setMarkDoneStatus";
            service.postServiceCall(url, postData).then((json) => {
                console.log(json);
                if (parseInt(json['msg']) == 1) {
                    this.setState({ testSaveStatus: true });
                } else {
                    service.showAlert("Fail");
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    setDateRange() {
        let cDate = new Date();
        let year = cDate.getFullYear();
        let month = cDate.getMonth() + 1;
        let day = cDate.getDate();
        month = month > 9 ? month : "0" + month;
        day = day > 9 ? day : "0" + day;
        this.setState({ minTestDate: '1980-01-01' });
        this.setState({ maxTestDate: year + '-' + month + '-' + day });
    }

    closeTestStatusPopup() {
        this.setState({ testSaveStatus: false }, () => {
            if (this.state.initialData && this.state.initialData[0] && this.state.initialData[0]['title']) {
                let newTitle = this.state.initialData[0]['title'].trim().replace(/\s/g, "_").replace(/\//g, "+");
                // this.props.history.push(service.getRedirectUrl("/tools/pregnancy-checkup-schedule/manageReports/" + newTitle + '/' + this.testId));
                window.location.href = service.getRedirectUrl("/tools/pregnancy-checkup-schedule/manageReports/" + newTitle + '/' + this.testId);
            }
        });
    }

    onDateChange(e){
        this.setState({takenonCalDate:e.target.value});
        console.log("date on change event",e.target.value);
    }

    render() {
        return (
            <main className="main-container pis-main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools/pregnancy-checkup-schedule")} className="R11_9e">Pregnancy Inspection Schedule</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        {this.state.initialData && this.state.initialData[0] && this.state.initialData[0]['title'] ?
                            <span><a href={service.getRedirectUrl(`/tools/pregnancy-checkup-schedule/manageReports/${this.state.initialData[0]['title'].trim().replace(/\s/g, "_").replace(/\//g, "+")}/${this.testId}`)} className="R11_9e">Manage Reports</a></span>
                            :
                            <span>Manage Reports</span>
                        }
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Update Details</span>
                    </div>
                    {this.state.initialData && this.state.initialData[0] && this.state.initialData[0]['title'] &&
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.state.initialData[0]['title'] + " - Update Details"}</h1>
                    }
                </div>
                <div className="sub-container left pis_details_sub_conterner_remainder_360">
                    <div className="data-container left">
                        <div className="updatedet-cnt">
                            {this.state.markdoneData &&
                                <div className="update-details">
                                    <div className="suppliment">
                                        {this.state.markdoneData['title'] &&
                                            <div className="supp-name B14_42">{this.state.markdoneData['title'].trim()}</div>
                                        }
                                        {this.state.markdoneData['startWeek'] && this.state.markdoneData['endWeek'] &&
                                            <span className="supp-week">{this.state.markdoneData['startWeek'] + "-" + this.state.markdoneData['endWeek'] + " Weeks "}</span>
                                        }
                                        {this.state.markdoneData['endWeek'] &&
                                            <span className="nth-trimester R12_75">({actions.getPragnancyTrimesterText(this.state.markdoneData['endWeek'])})</span>
                                        }
                                    </div>
                                    {this.state.markdoneData['date'] &&
                                        <div className="taken-on">
                                            <span className="taken left R15_21">Taken On</span>
                                            <span className="icon calender" data-icon-font="w"></span>
                                            <input className="taken-dt R13_fc right" type="text" defaultValue={actions.getDateStringPis(this.state.markdoneData['date'])} readOnly onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} onBlur={(e) => service.onBlurDate(e)} onChange={(e) => this.onDateChange(e)} min={this.state.minTestDate} max={this.state.maxTestDate} />
                                        </div>
                                    }
                                    <div className="supp-content">
                                        <div className="save-test left">
                                            <span className="B14_42">Save Test [?]</span>
                                            <div className="comment-note R13_9e">Upload your test results and can get access in future as well.</div>
                                        </div>
                                        <div className="image_bx right">
                                            <div className="vc_up_img">
                                                <input type="hidden" name="uploadImage" value= {this.state.testImage}/>
                                                <img id="vaximage" src={(this.state.testImage && this.state.testImage != '') ? this.state.testImage : require('../images/pis/vaccine_chart_img.png')} onError={(e) => { e.target.src = require('../images/pis/vaccine_chart_img.png')}} />
                                            </div>
                                            <div className="up_img_mn">
                                                <label htmlFor="image_upload">
                                                    <span className="upload icon" data-icon-font="x"></span>
                                                </label>
                                                <input type="file" id="image_upload" onChange={() => this.pisFileUpload()} style={{ display: 'none' }} />
                                            </div>
                                            <div className="file_upload_err"></div>
                                        </div>
                                    </div>
                                    <textarea id="testComment" className="add-comment R14_75" maxLength="250" placeholder="Add your comments about Inspection report or Doctor's details in 250 characters" defaultValue={this.state.testComment}></textarea>
                                    <div className="save-btn" onClick={() => this.setMarkDoneStatus()}>
                                        <span className="M15_white saveBtn">SAVE</span>
                                    </div>
                                </div>
                            }
                            {this.state.testSaveStatus &&
                                <div className="test-status-save">
                                    <div className="save-success">
                                        <div className="R15_42">Test status saved successfully</div>
                                        <div className="status-ok M15_fc88af" onClick={() => { this.closeTestStatusPopup(); }}>OK</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(PisUpdateDetail);
